export default __webpack_public_path__ + "static/media/c-jankikund.a087aad7.jpg";